import 'css-chunksrc/client/common/secondaryCriteriaForm/documentForm/directoryStructure/styles.scss';export default {
  "folder": "_folder_s5lyt_1",
  "document": "_document_s5lyt_13",
  "folderIcon": "_folderIcon_s5lyt_28",
  "documentIcon": "_documentIcon_s5lyt_35"
};